import { is } from '@babel/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Image } from 'primereact/image';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Link } from "react-router-dom";

class AppSubmenu extends Component {

    static defaultProps = {
        className: null,
        items: null,
        acoes: null,
        onMenuItemClick: null,
        root: false,
        itemPai: true,
        menuAberto: true
    }

    static propTypes = {
        className: PropTypes.string,
        items: PropTypes.array,
        acoes: PropTypes.array,
        onMenuItemClick: PropTypes.func,
        root: PropTypes.bool,
        itemPai: PropTypes.bool,
        menuAberto: PropTypes.bool
    }

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: null,
            selectedPath: "/"
        };
    }

    onMenuItemClick(event, item, index) {

        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        //prevent hash change
        if ((item.subItems && item.subItems.length > 0) || !item.path) {
            event.preventDefault();
            if (index === this.state.activeIndex)
                this.setState({ activeIndex: null });
            else
                this.setState({ activeIndex: index });

        } else {
            this.setState({ activeIndex: index });
        }



        if (this.props.onMenuItemClick) {
            this.props.onMenuItemClick({
                originalEvent: event,
                item: item
            });
        }
    }

    isActive(active) {
        return active && this.props.menuAberto;
    }

    render() {

        let items = null;

        let itemsFiltro = this.props.items && this.props.items.length > 0
            && this.props.items.filter(
                i => (i.subItems.length > 0 && i.subItems.map(sub => this.props.acoes.map(a => a.sigla).indexOf(sub.acao) > -1).includes(true))
                    || this.props.acoes.map(a => a.sigla).indexOf(i.acao) > -1
            );
        if (itemsFiltro) {
            items = itemsFiltro.map((item, i) => {
                let active = this.state.activeIndex === i;
                let styleClass = classNames({
                    'active-menuitem': this.isActive(active),
                    'layout-father-menuitem': item.subItems.length > 0,
                });
                let img = item.icon ? <img src={item.icon} alt={item.iconLicense ? item.iconLicense : ""} /> : <></>;

                let submenuIcon = item.subItems.length > 0 && (active ?
                    <div className={this.props.itemPai ? 'menuitem-toggle-icon-pai' : 'menuitem-toggle-icon'} ><FontAwesomeIcon icon="angle-up" /></div>
                    :
                    <div className={this.props.itemPai ? 'menuitem-toggle-icon-pai' : 'menuitem-toggle-icon'} ><FontAwesomeIcon icon="angle-down" /></div>
                );
                return (
                    <li className={styleClass} key={i + item.title}>
                        {item.subItems.length > 0 && this.props.root === true && <div className='arrow'></div>}

                        {item.path && (
                            <Link to={item.path} onClick={(e) => this.onMenuItemClick(e, item, i)}>
                                {this.props.itemPai ? img : null}
                                <span className="title">{item.title}</span>
                                {this.props.menuAberto ? submenuIcon : null}
                            </Link>
                        )}
                        {!item.path && item.subItems.length > 0 && (
                            <a href={item.path} onClick={(e) => this.onMenuItemClick(e, item, i)} target={item.target} style={{ paddingRight: 4 }}>
                                <span className="title">{item.title}</span>
                                {submenuIcon}
                            </a>
                        )}
                        <AppSubmenu items={item.subItems} menuAberto={this.props.menuAberto} onMenuItemClick={this.props.onMenuItemClick} acoes={this.props.acoes} itemPai={false} />
                    </li>
                )

            });
        }

        return items ? <ul className={".module-list " + this.props.className}>{items}</ul> : null;
    }
}

export class AppMenu extends Component {

    static defaultProps = {
        model: null,
        acoes: null,
        onMenuItemClick: null,
        menuAberto: true
    }

    static propTypes = {
        model: PropTypes.array,
        acoes: PropTypes.array,
        onMenuItemClick: PropTypes.func,
        menuAberto: PropTypes.bool
    }

    render() {
        return <div className="menu"><AppSubmenu items={this.props.model} menuAberto={this.props.menuAberto} acoes={this.props.acoes} className="layout-main-menu" onMenuItemClick={this.props.onMenuItemClick} root={true} /></div>
    }
}